import { render, staticRenderFns } from "./CreatePlanGroup.vue?vue&type=template&id=28e8b634&"
import script from "./CreatePlanGroup.vue?vue&type=script&lang=js&"
export * from "./CreatePlanGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports